


















































import {
  defineComponent, ref, useContext, useFetch,
} from '@nuxtjs/composition-api';
import { PropType } from 'vue';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import { addBasePath } from '~/helpers/addBasePath';
import SearchBar from '~/modules/storyblok/components/Blog/SearchBar.vue';
import useBlogCategories from '~/modules/storyblok/composables/useBlogCategories';

interface Blok {
  image: IBlokSingleImage[];
  title: string;
  description?: string;
}

export default defineComponent({
  name: 'BlogHero',
  components: {
    SearchBar,
  },
  props: {
    blok: {
      type: Object as PropType<Blok>,
      required: true,
    },
  },
  setup() {
    const searchTerm = ref('');
    const {
      mainCategories,
      currentCategoryFullSlug,
      load: loadCategories,
    } = useBlogCategories();
    const { $localeSbUrl } = useContext();
    const handleSearch = () => {
      console.log('search', searchTerm.value);
    };

    const categoryLink = (link) => $localeSbUrl({ slug: link });

    const { fetch } = useFetch(async () => {
      await loadCategories();
    });
    fetch();

    return {
      searchTerm,
      addBasePath,
      handleSearch,
      mainCategories,
      currentCategoryFullSlug,
      categoryLink,
    };
  },
});
